import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { AdminService } from "../../../services/api/admin.service";
import { MpAdminActions } from "../../actions/mp-admin.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class ConsumerDenyEffects {
	activate = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.consumer.deny),
			switchMap((action) =>
				this.mpAdminService.denyConsumer(action.id).pipe(
					map(() => MpAdminActions.consumer.denySuccess({ id: action.id })),
					catchError((error) =>
						of(MpAdminActions.consumer.denyFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private mpAdminService: AdminService
	) {}
}
